// extracted by mini-css-extract-plugin
export default {"max_width":"global_max_width__Q7Yrt","navextra":"global_navextra__rOKp3"};